<template>
  <b-modal
    id="role-quota-upgrade-modal"
    v-model="localVisible"
    modal-class="rq-upgrade-modal"
    dialog-class="rq-upgrade-modal__dialog"
    content-class="rq-upgrade-modal__content border-0"
    body-class="rq-upgrade-modal__body p-0"
    centered
    hide-header
    hide-footer
    @hidden="onHidden"
  >
    <div class="rq-upgrade">
      <div class="rq-upgrade__hero">
        <button
          type="button"
          class="rq-upgrade__close"
          aria-label="Close"
          t_label="EMPBE_UserSetting_UpgradeModal_Close"
          @click="close"
        >
          <img :src="cdnClose" alt="" width="24" height="24" />
        </button>
        <img class="rq-upgrade__illust" :src="cdnHero" alt="" />
      </div>

      <div class="rq-upgrade__main">
        <h2 class="rq-upgrade__title">
          {{ $t('EMP_UserSetting_UpgradePlanTitle') }}
        </h2>
        <p class="rq-upgrade__desc">
          {{ $t('EMP_UserSetting_UpgradePlanDesc') }}
        </p>
        <ul class="rq-upgrade__benefits">
          <li v-for="key in benefitKeys" :key="key">
            <img :src="cdnDone" alt="" width="24" height="24" />
            <span>{{ $t(key) }}</span>
          </li>
        </ul>
        <div class="rq-upgrade__actions">
          <a
            class="rq-upgrade__btn-learn"
            :href="learnMoreUrl"
            target="_blank"
            rel="noopener"
            t_label="EMPBE_UserSetting_UpgradeModal_LearnMore"
          >{{ $t('lbl_EMPBE_SalesLead_LearnMore') }}</a>
          <button
            type="button"
            class="rq-upgrade__btn-sales"
            t_label="EMPBE_UserSetting_UpgradeModal_ContactSales"
            @click="onContactSales"
          >{{ $t('lbl_EMPBE_EPO_Banner_ContactSales') }}</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
const CDN_BASE = 'https://cdn.adsalecdn.com/EMP/2-0/SourcingReques/';

export default {
  name: 'RoleQuotaUpgradeModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    learnMoreUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localVisible: this.value,
      cdnHero: `${CDN_BASE}SourcingRequest_Quota_hero.svg`,
      cdnClose: `${CDN_BASE}SourcingRequest_Quota_close.svg`,
      cdnDone: `${CDN_BASE}SourcingRequest_Quota_done.svg`,
      benefitKeys: [
        'EMP_UserSetting_UpgradePlanBenefit1',
        'EMP_UserSetting_UpgradePlanBenefit2',
        'EMP_UserSetting_UpgradePlanBenefit3',
      ],
    };
  },
  watch: {
    value(v) {
      this.localVisible = v;
    },
    localVisible(v) {
      if (v !== this.value) this.$emit('input', v);
    },
  },
  methods: {
    close() {
      this.localVisible = false;
    },
    onHidden() {
      this.$emit('input', false);
      this.$emit('close');
    },
    onContactSales() {
      this.$emit('contact-sales');
      this.close();
    },
  },
};
</script>

<style lang="scss">
/* Figma 4165:248401 / 同系 DayLimit 3385:424772 */
.rq-upgrade-modal {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-content {
    border: 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
  }
}
</style>

<style lang="scss" scoped>
.rq-upgrade {
  background: #fff;
}

.rq-upgrade__hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 184px;
  padding: 12px 16px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #6231ff;
  background-image:
    radial-gradient(ellipse at 98% 114%, #ff7931 0%, #e4705d 11%, #ca6689 23%, #af5db5 34%, #9554e2 45%, #8550ff 75%, #6231ff 100%),
    url('https://cdn.adsalecdn.com/EMP/2-0/SourcingReques/SourcingRequest_Quota_hero-bg.png');
  background-size: cover, cover;
  background-position: center, center;
}

.rq-upgrade__illust {
  width: 220px;
  height: 160px;
  max-width: 70%;
  display: block;
  position: relative;
  z-index: 1;
  object-fit: contain;
}

.rq-upgrade__close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 2;
  line-height: 0;
}

.rq-upgrade__main {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  box-sizing: border-box;
}

.rq-upgrade__title {
  margin: 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.rq-upgrade__desc {
  margin: 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.rq-upgrade__benefits {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  img {
    flex-shrink: 0;
    display: block;
  }

  span {
    flex: 1;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    opacity: 0.9;
  }
}

.rq-upgrade__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.rq-upgrade__btn-learn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 12px;
  border-radius: 4px;
  color: #7366ff !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none !important;
  background: #fff;
}

.rq-upgrade__btn-sales {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 12px;
  border: 0;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  background: #7366ff;
  cursor: pointer;
}

@media (max-width: 575px) {
  .rq-upgrade__title {
    font-size: 20px;
  }

  .rq-upgrade__main {
    padding: 16px;
  }
}
</style>
